<template>
  <div v-if="!container.isActive && enableStale">Stale</div>
  <span
    v-else
    v-tippy="getYardStatusTooltipText()"
    class="tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700"
    :class="yardStatusBackgroundClasses[container.yardStatus]"
  >{{ getYardStatusLabelText() }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Matches the unselected status filter pills in ContainerTableView.vue
const yardStatusBackgroundClasses: Record<string, string> = {
  Unknown: 'tw-bg-amber-100',
  NotFound: 'tw-bg-orange-100',
  Onboard: 'tw-bg-blue-100',
  NotAvailable: 'tw-bg-red-200',
  Available: 'tw-bg-emerald-100',
  OffDock: 'tw-bg-slate-100',
};

const yardStatusesWithDefaultTooltip = ['NotAvailable', 'NotFound'];

export default defineComponent({
  props: ['container', 'enableStale'],
  data() {
    return {
      yardStatusBackgroundClasses,
    };
  },
  methods: {
    getYardStatusLabelText(): string {
      return this.container.yardStatus === 'Onboard' ? 'Onboard Vessel' : this.container.yardStatusDescription.split('\n')[0];
    },
    getYardStatusTooltipText(): string | undefined {
      const secondLine = this.container.yardStatusDescription.split('\n')[1];
      if (secondLine && secondLine !== '\xa0') {
        return secondLine;
      }
      return yardStatusesWithDefaultTooltip.includes(this.container.yardStatus) ? 'Not Available Yet!' : undefined;
    },
  },
});
</script>
